import { Container, Table, Toggle, Tooltip } from "@fluidattacks/design";
import { Fragment, StrictMode, useMemo, useState } from "react";
import type { FC } from "react";
import { useTranslation } from "react-i18next";

import type { IVulnerabilitiesToVerifyProps } from "./types";
import { getColumns } from "./utils";

import type { IVulnData } from "../types";
import { useTable } from "hooks/use-table";

const VulnerabilitiesToVerify: FC<IVulnerabilitiesToVerifyProps> = ({
  handleOnChange,
  isOpen,
  setVulnerabilitiesList,
  vulnerabilitiesList,
}): JSX.Element => {
  const { t } = useTranslation();
  const [search, setSearch] = useState<string | undefined>("");

  const handleUpdateRepo = (vulnInfo: Record<string, string>): void => {
    const newVulnList = vulnerabilitiesList.map(
      (vuln): IVulnData =>
        vuln.id === vulnInfo.id
          ? {
              ...vuln,
              state: vuln.state === "VULNERABLE" ? "SAFE" : "VULNERABLE",
            }
          : vuln,
    );
    setVulnerabilitiesList([...newVulnList]);
  };

  const columns = getColumns(handleUpdateRepo);

  const formattedVulns = useMemo(
    (): IVulnData[] =>
      vulnerabilitiesList.filter(
        ({ where, specific }): boolean =>
          where.toLowerCase().includes(search?.toLowerCase() ?? "") ||
          specific.toLowerCase().includes(search?.toLowerCase() ?? ""),
      ),
    [vulnerabilitiesList, search],
  );

  const { table } = useTable({
    columns,
    data: formattedVulns,
    id: "vulnerabilities-to-verify",
    options: {
      actionsOptions: { onSearch: setSearch },
      filtersMode: "client-side",
      paginationMode: "client-side",
    },
    total: formattedVulns.length,
  });

  return (
    <StrictMode>
      <Fragment>
        <Tooltip
          id={"toogleToolTip"}
          place={"top"}
          tip={t(
            "searchFindings.tabDescription.remediationModal.globalSwitch.tooltip",
          )}
        >
          <Container display={"flex"} flexDirection={"row-reverse"}>
            <Toggle
              defaultChecked={isOpen}
              leftDescription={`${t(
                "searchFindings.tabDescription.remediationModal.globalSwitch.text",
              )} to Safe`}
              name={"verification-switch"}
              onChange={handleOnChange}
              rightDescription={"Vulnerable"}
            />
          </Container>
        </Tooltip>
        <Table table={table}>
          <Table.Options />
          <Table.Content />
          <Table.Footer />
        </Table>
      </Fragment>
    </StrictMode>
  );
};

export { VulnerabilitiesToVerify };
